<ng-container>
  <div class="badge">
    <span class="badge-text">{{ text }}</span>
    <app-full-immersion-icon></app-full-immersion-icon>
  </div>
</ng-container>
